module.exports = __webpack_public_path__ + "img/HR.bebc145d.png";